var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "dialogBox",
        _vm.isRight == 1
          ? "dialogBox_small"
          : _vm.isRight == 2
          ? "dialogBox_big"
          : "",
      ],
    },
    [
      _vm.actDialogId != "" || _vm.notNew
        ? _c(
            "div",
            { ref: "dialogflex", staticClass: "dialog-flex" },
            [
              _vm.sessionLoading
                ? [_c("loadingSkeleton")]
                : _vm._l(_vm.dialoglist, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "dialog-item" },
                      [
                        _c("div", { staticClass: "me" }, [
                          _c("span", { staticClass: "head-user" }, [
                            _vm._v(_vm._s(_vm.Avatar)),
                          ]),
                          _c("div", { staticClass: "question" }, [
                            _c("p", [_vm._v(_vm._s(item.sendContent))]),
                          ]),
                        ]),
                        _c("div", { staticClass: "rebot" }, [
                          _c(
                            "div",
                            { staticClass: "rebot-content" },
                            [
                              _c("svg-icon", {
                                staticClass: "airebot",
                                attrs: { name: "airebot" },
                              }),
                              _c("div", { staticClass: "answer" }, [
                                _c("div", { staticClass: "answer-wrap" }, [
                                  _c(
                                    "p",
                                    [
                                      _vm.isShowLoading(index)
                                        ? _c("span", {
                                            staticClass: "dot-flashing",
                                          })
                                        : [
                                            _c("searchList", {
                                              attrs: { item: item },
                                            }),
                                            item.searchState &&
                                            item.searchState != 3
                                              ? _c("span", {
                                                  staticClass: "dot-flashing",
                                                })
                                              : _vm._e(),
                                            _c("vue-markdown", {
                                              attrs: {
                                                source: item.replyContent,
                                                linkify: false,
                                                anchorAttributes: {
                                                  target: "_blank",
                                                },
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.isShowLoadingMore(index)
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-divider"),
                                          _c("span", {
                                            staticClass: "dot-flashing",
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  item.dataType > 0 &&
                                  (item.tabledata.result.length > 0 ||
                                    (item.chartdata &&
                                      Object.keys(item.chartdata).length))
                                    ? _c(
                                        "div",
                                        { staticClass: "extra-box" },
                                        [
                                          _c("el-divider"),
                                          _c("dataList", {
                                            attrs: { datalist: item },
                                            on: {
                                              "update:datalist": function (
                                                $event
                                              ) {
                                                item = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : item.dataType == -2 &&
                                      item.jsonData &&
                                      item.jsonData.recommendQ &&
                                      (item.jsonData.recommendQ.length > 0 ||
                                        item.jsonData.idTitle.length > 0)
                                    ? _c(
                                        "div",
                                        { staticClass: "extra-box" },
                                        [
                                          _c("el-divider"),
                                          _c(
                                            "span",
                                            { staticClass: "firstQ" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$i18.language(
                                                    "了解详细信息"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("moreReport", {
                                            attrs: { data: item },
                                            on: {
                                              "update:data": function ($event) {
                                                item = $event
                                              },
                                              setQusetType: _vm.setQusetType,
                                              sendQuest: _vm.sendQuest,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : item.dataType == -3
                                    ? _c(
                                        "div",
                                        { staticClass: "extra-box" },
                                        [
                                          _c("el-divider"),
                                          _c("moreReport", {
                                            attrs: { data: item },
                                            on: {
                                              "update:data": function ($event) {
                                                item = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isShowOption(index),
                                        expression: "isShowOption(index)",
                                      },
                                    ],
                                    staticClass: "answer-option",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rebuild",
                                        on: {
                                          click: function ($event) {
                                            return _vm.rebuild(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$i18.language("重新生成"))
                                        ),
                                      ]
                                    ),
                                    _c("div", { staticClass: "right-option" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "copy-button",
                                          on: {
                                            click: function ($event) {
                                              return _vm.copy(item.replyContent)
                                            },
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: { name: "copy" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            item.score == 1 ? "actived" : "",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.feedback(item, 1)
                                            },
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            class: [
                                              _vm.showAnimate == item.uniqueKey
                                                ? "liked"
                                                : "",
                                            ],
                                            attrs: { name: "like" },
                                            on: {
                                              animationend: function ($event) {
                                                _vm.showAnimate = ""
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            item.score &&
                                            item.score != 1 &&
                                            item.score != 0
                                              ? "actived"
                                              : "",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.moreFeedback(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: { name: "dislike" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
            ],
            2
          )
        : [
            _c("pre-loading", {
              ref: "preLoading",
              attrs: { isRight: _vm.isRight },
              on: {
                "update:isRight": function ($event) {
                  _vm.isRight = $event
                },
                "update:is-right": function ($event) {
                  _vm.isRight = $event
                },
              },
            }),
          ],
      _c("div", { staticClass: "input-box" }, [
        _c("div", { staticClass: "blur-box" }),
        _c(
          "div",
          { staticClass: "type-btn" },
          [
            _c(
              "el-dropdown",
              { attrs: { placement: "top", trigger: "click" } },
              [
                _c(
                  "el-button",
                  {
                    class: [_vm.questionType ? "checkedQuestType" : ""],
                    attrs: { plain: "" },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.questionTypeText) + " "),
                    _vm.questionType
                      ? _c("svg-icon", {
                          attrs: { name: _vm.questionTypeIconName },
                        })
                      : _vm._e(),
                    _vm.questionType
                      ? _c("span", { staticClass: "questionTypeText" }, [
                          _vm._v(_vm._s(_vm.getQuestionType(_vm.questionType))),
                        ])
                      : _vm._e(),
                    _c("svg-icon", { attrs: { name: "changetype" } }),
                  ],
                  1
                ),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "div",
                      { staticClass: "dropdown-option" },
                      _vm._l(_vm.questionTypeList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.value,
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.changeQuestionType(item)
                              },
                            },
                          },
                          [
                            _c("svg-icon", { attrs: { name: item.key } }),
                            _c("span", { staticClass: "question-type" }, [
                              _vm._v(_vm._s(item.text)),
                            ]),
                            _c(
                              "div",
                              { staticClass: "radio" },
                              [
                                _vm.questionType == item.value
                                  ? _c("svg-icon", {
                                      staticClass: "check_status",
                                      attrs: { name: "checked" },
                                    })
                                  : _c("svg-icon", {
                                      staticClass: "check_status",
                                      attrs: { name: "uncheck" },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.questionType == 4
              ? _c(
                  "el-button",
                  {
                    staticClass: "reportBtn",
                    attrs: { plain: "" },
                    on: { click: _vm.changeReport },
                  },
                  [
                    !_vm.reportInfo
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$i18.language("选择具体报告"))),
                        ])
                      : [
                          _c("svg-icon", {
                            staticClass: "pdf",
                            staticStyle: {
                              "font-size": "20px",
                              "vertical-align": "-0.25em",
                            },
                            attrs: { name: "pdf" },
                          }),
                          _c("span", { staticClass: "reportTitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.reportInfo.en_title || _vm.reportInfo.title
                              )
                            ),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "clearReport",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clearBtn.apply(null, arguments)
                                },
                              },
                            },
                            [_c("svg-icon", { attrs: { name: "deleteIcon" } })],
                            1
                          ),
                        ],
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "el-popover",
              {
                attrs: {
                  "popper-class": "websearch-popover",
                  placement: "top-start",
                  trigger: "hover",
                  content: _vm.webSearchTip,
                },
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.questionType != 4,
                        expression: "questionType != 4",
                      },
                    ],
                    class: [
                      _vm.QA_args.webSearch ? "webSearch-on-btn" : "",
                      "webSearch-btn",
                    ],
                    attrs: { slot: "reference", plain: "" },
                    on: { click: _vm.openWebSearch },
                    slot: "reference",
                  },
                  [
                    _c("svg-icon", {
                      attrs: {
                        name: _vm.QA_args.webSearch ? "global" : "no_global",
                      },
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.QA_args.webSearch
                            ? _vm.$i18.language("已联网")
                            : _vm.$i18.language("联网")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.isRight == 1
              ? _c(
                  "el-button",
                  {
                    staticClass: "confirm-btn-plain addDialogBtn",
                    attrs: { plain: "" },
                    on: { click: _vm.newDialog },
                  },
                  [_vm._v(_vm._s(_vm.$i18.language("新建对话")))]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input-textarea" },
          [
            _c("span", { staticClass: "lengthTips" }, [
              _vm._v(_vm._s(_vm.qusetiontextarea.length) + " / 1000"),
            ]),
            _c("el-input", {
              ref: "inputRef",
              attrs: {
                type: "textarea",
                maxlength: 1000,
                autosize: { minRows: 4, maxRows: 6 },
                placeholder: _vm.$i18.language(
                  "Enter 发送；Shift/Cmd + Enter 换行"
                ),
              },
              nativeOn: {
                keydown: function ($event) {
                  return _vm.changeInput.apply(null, arguments)
                },
              },
              model: {
                value: _vm.qusetiontextarea,
                callback: function ($$v) {
                  _vm.qusetiontextarea = $$v
                },
                expression: "qusetiontextarea",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "sendQusetion",
                style: _vm.lang == "en" ? "bottom: 40px" : "",
                on: { click: _vm.sendQusetion },
              },
              [_vm._v(_vm._s(_vm.$i18.language("发送")))]
            ),
            ["TR"].includes(_vm.$util.judgeOrigin())
              ? _c("span", { staticClass: "bottom-desc" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$i18.language(
                        "内容由AI生成，仅供参考，请遵守《特易用户协议》，特易GT大模型版本：V6.0.0(TRU)"
                      )
                    )
                  ),
                ])
              : _c("span", { staticClass: "bottom-desc" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$i18.language(
                        "内容由AI生成，仅供参考，请遵守《特易用户协议》，特易GT大模型版本：V6.0.0"
                      )
                    )
                  ),
                ]),
          ],
          1
        ),
      ]),
      _vm.feedbackType.dialogVisible
        ? _c("feedBack", {
            attrs: { feedbackType: _vm.feedbackType },
            on: {
              "update:feedbackType": function ($event) {
                _vm.feedbackType = $event
              },
              "update:feedback-type": function ($event) {
                _vm.feedbackType = $event
              },
            },
          })
        : _vm._e(),
      _c("marketReport", {
        ref: "marketReport",
        on: { selectReport: _vm.selectReport },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }